import SimpleParallax from "simple-parallax-js/vanilla";

export function initParallax() {
    return [...document.querySelectorAll(".c-mediafull:not(.-initialized).-parallax")].map((el) => {
        let parallaxBackground = new ParallaxBackground(el);
        let videoBackground = new VideoBackground(el);
        parallaxBackground.initialize();
        videoBackground.initialize();
    });
}

class VideoBackground {
    constructor(element) {
        this.element = element;
        this.element.classList.add('-initialized');
    }
    initialize() {
        let videos = this.element.querySelectorAll('video');
        videos.forEach((element) => {
            // start playing on page transition
            element.play();
        });
    }
}

class ParallaxBackground {
    constructor(element) {
        this.element = element;
        this.element.classList.add('-initialized');
    }

    initialize() {
        let elements = this.element.querySelectorAll('.-parallax video, .-parallax iframe, .-parallax img');
        if (elements.length > 0) {
            new SimpleParallax(elements, {
                scale: 1.25,
            });
        }
    }
}
